import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  BellIcon, HeartIcon, SearchIcon, XIcon,
  MapPinIcon, StarIcon, PackageIcon, BookmarkIcon, BookmarkFillIcon, BadgeCheckIcon,
  CalendarIcon, ChevronIcon,
} from '../../components/Icons';
import AdBanner from '../../components/AdBanner';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const token = () => localStorage.getItem('kialuga_token');

export default function Explorar() {
  const navigate = useNavigate();
  const [produtos,     setProdutos]     = useState([]);
  const [categorias,   setCategorias]   = useState([]);
  const [carregando,   setCarregando]   = useState(true);
  const [carregandoMais, setCarregandoMais] = useState(false);
  const [activeCat,    setActiveCat]    = useState('');
  const [search,       setSearch]       = useState('');
  const [searchInput,  setSearchInput]  = useState('');
  const [favoritos,    setFavoritos]    = useState(new Set());
  const [pagina,       setPagina]       = useState(1);
  const [temMais,      setTemMais]      = useState(true);
  const [naoLidas,     setNaoLidas]     = useState(0);
  // Filtro de datas
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [dataInicio,   setDataInicio]   = useState('');
  const [dataFim,      setDataFim]      = useState('');
  const [dataActiva,   setDataActiva]   = useState(false);
  const [ads,          setAds]          = useState([]);

  const LIMIT = 12;

  useEffect(() => {
    fetch(`${BASE}/anuncios/categorias`)
      .then(r => r.json())
      .then(d => { if (d.sucesso) setCategorias(d.categorias); })
      .catch(() => {});

    fetch(`${BASE}/publicidade/ativos`)
      .then(r => r.json())
      .then(d => { if (d.sucesso) setAds(d.publicidade || []); })
      .catch(() => {});

    if (token()) {
      fetch(`${BASE}/favoritos`, { headers: { Authorization: `Bearer ${token()}` } })
        .then(r => r.json())
        .then(d => { if (d.sucesso) setFavoritos(new Set(d.favoritos.map(f => f.anuncio_id))); })
        .catch(() => {});
      fetch(`${BASE}/notificacoes`, { headers: { Authorization: `Bearer ${token()}` } })
        .then(r => r.json())
        .then(d => { if (d.sucesso) setNaoLidas(d.notificacoes.filter(n => !n.lida).length); })
        .catch(() => {});
    }
  }, []);

  useEffect(() => {
    setProdutos([]);
    setPagina(1);
    setTemMais(true);
    carregarProdutos(1, true);
  // eslint-disable-next-line
  }, [activeCat, search, dataActiva]);

  const carregarProdutos = useCallback(async (pg = 1, reset = false) => {
    if (reset) setCarregando(true);
    else setCarregandoMais(true);
    try {
      const params = new URLSearchParams({ limit: LIMIT, page: pg });
      if (activeCat) params.append('categoria', activeCat);
      if (search)    params.append('q', search);
      if (dataActiva && dataInicio && dataFim) {
        params.append('data_inicio', dataInicio);
        params.append('data_fim', dataFim);
      }
      const res  = await fetch(`${BASE}/anuncios?${params}`);
      const data = await res.json();
      if (data.sucesso) {
        const novos = data.anuncios || [];
        if (reset) setProdutos(novos);
        else setProdutos(prev => [...prev, ...novos]);
        setTemMais(novos.length === LIMIT);
        setPagina(pg);
      }
    } catch (err) {
      console.error('Erro ao carregar produtos:', err);
    } finally {
      setCarregando(false);
      setCarregandoMais(false);
    }
  }, [activeCat, search, dataActiva, dataInicio, dataFim]);

  const carregarMais = () => {
    if (!carregandoMais && temMais) carregarProdutos(pagina + 1, false);
  };

  const toggleFavorito = async (e, anuncioId) => {
    e.stopPropagation();
    if (!token()) { navigate('/login'); return; }
    try {
      const res  = await fetch(`${BASE}/favoritos/${anuncioId}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token()}` },
      });
      const data = await res.json();
      if (data.sucesso) {
        setFavoritos(prev => {
          const next = new Set(prev);
          data.favorito ? next.add(anuncioId) : next.delete(anuncioId);
          return next;
        });
      }
    } catch {}
  };

  const pesquisar = (e) => {
    e.preventDefault();
    setSearch(searchInput);
  };

  const aplicarDatas = () => {
    if (dataInicio && dataFim && dataInicio <= dataFim) {
      setDataActiva(true);
      setMostrarFiltros(false);
    }
  };

  const limparDatas = () => {
    setDataInicio('');
    setDataFim('');
    setDataActiva(false);
  };

  const gradientes = [
    'linear-gradient(135deg,#fde8d8,#fed7b0)',
    'linear-gradient(135deg,#dbeafe,#bfdbfe)',
    'linear-gradient(135deg,#dcfce7,#bbf7d0)',
    'linear-gradient(135deg,#fef9c3,#fde68a)',
    'linear-gradient(135deg,#fce7f3,#fbcfe8)',
    'linear-gradient(135deg,#ede9fe,#ddd6fe)',
  ];

  const hoje = new Date().toISOString().split('T')[0];

  return (
    <>
      <div className="topbar">
        <div>
          <div className="topbar-title">Descobrir produtos</div>
          <div className="topbar-sub">{carregando ? 'A carregar...' : `${produtos.length}${temMais ? '+' : ''} produtos disponíveis`}</div>
        </div>
        <div className="topbar-actions">
          <button className="btn btn-outline" onClick={() => navigate('/cliente/favoritos')}
            style={{display:'flex',alignItems:'center',gap:'6px'}}>
            <HeartIcon size={14}/> Favoritos
          </button>
          <button className="btn btn-ghost" onClick={() => navigate('/notificacoes')}
            style={{position:'relative',padding:'8px'}}>
            <BellIcon size={18}/>
            {naoLidas > 0 && (
              <span style={{position:'absolute',top:'4px',right:'4px',width:'16px',height:'16px',background:'var(--orange)',borderRadius:'50%',fontSize:'9px',fontWeight:'700',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center'}}>
                {naoLidas > 9 ? '9+' : naoLidas}
              </span>
            )}
          </button>
        </div>
      </div>

      <div className="page-content">
        {/* Hero Search */}
        <div style={{background:'var(--brand-dark)',borderRadius:'var(--radius-lg)',padding:'24px',marginBottom:'20px',position:'relative',overflow:'hidden'}}>
          <div style={{position:'absolute',top:'-40px',right:'-40px',width:'200px',height:'200px',borderRadius:'50%',background:'rgba(249,115,22,0.12)',pointerEvents:'none'}}></div>
          <div style={{fontSize:'20px',fontWeight:'700',color:'#fff',marginBottom:'4px',fontFamily:'Syne,sans-serif'}}>O que precisas hoje?</div>
          <div style={{fontSize:'13px',color:'rgba(255,255,255,0.5)',marginBottom:'16px'}}>Aluga ou compra produtos em Luanda · Pagamento protegido por escrow</div>
          <form onSubmit={pesquisar} style={{display:'flex',gap:'8px',position:'relative',zIndex:1}}>
            <div style={{flex:1,display:'flex',alignItems:'center',background:'rgba(255,255,255,0.1)',border:'1px solid rgba(255,255,255,0.15)',borderRadius:'9px',padding:'0 12px',gap:'8px'}}>
              <SearchIcon size={15} color='rgba(255,255,255,0.5)'/>
              <input style={{background:'transparent',border:'none',outline:'none',fontSize:'13px',color:'#fff',fontFamily:'inherit',flex:1,padding:'10px 0'}}
                placeholder="Ex: vestido de gala, câmara, tenda..."
                value={searchInput}
                onChange={e=>setSearchInput(e.target.value)} />
              {search && (
                <button type="button" style={{background:'none',border:'none',cursor:'pointer',display:'flex',alignItems:'center',padding:'0'}}
                  onClick={()=>{setSearch('');setSearchInput('');}}>
                  <XIcon size={13} color='rgba(249,115,22,0.8)'/>
                </button>
              )}
            </div>
            <button type="button"
              onClick={() => setMostrarFiltros(v => !v)}
              style={{padding:'10px 12px',background:mostrarFiltros||dataActiva?'var(--orange)':'rgba(255,255,255,0.1)',color:'#fff',border:'1px solid rgba(255,255,255,0.15)',borderRadius:'9px',fontSize:'13px',cursor:'pointer',display:'flex',alignItems:'center',gap:'5px'}}>
              <CalendarIcon size={14}/> {dataActiva ? `${dataInicio}` : 'Datas'}
            </button>
            <button type="submit" style={{padding:'10px 18px',background:'var(--orange)',color:'#fff',border:'none',borderRadius:'9px',fontSize:'13px',fontWeight:'600',cursor:'pointer',fontFamily:'inherit'}}>
              Pesquisar
            </button>
          </form>

          {/* Painel de filtro de datas */}
          {mostrarFiltros && (
            <div style={{marginTop:'12px',background:'rgba(255,255,255,0.08)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:'10px',padding:'14px',position:'relative',zIndex:2}}>
              <div style={{fontSize:'12px',color:'rgba(255,255,255,0.6)',marginBottom:'10px',fontWeight:'500'}}>Filtrar por disponibilidade:</div>
              <div style={{display:'flex',gap:'10px',alignItems:'flex-end',flexWrap:'wrap'}}>
                <div style={{flex:1,minWidth:'120px'}}>
                  <label style={{fontSize:'10px',color:'rgba(255,255,255,0.4)',textTransform:'uppercase',display:'block',marginBottom:'4px'}}>Data início</label>
                  <input type="date" min={hoje} value={dataInicio}
                    onChange={e=>{setDataInicio(e.target.value);if(dataFim&&e.target.value>dataFim)setDataFim('');}}
                    style={{width:'100%',padding:'7px 10px',background:'rgba(255,255,255,0.1)',border:'1px solid rgba(255,255,255,0.15)',borderRadius:'7px',fontSize:'12px',color:'#fff',fontFamily:'inherit',outline:'none'}}/>
                </div>
                <div style={{flex:1,minWidth:'120px'}}>
                  <label style={{fontSize:'10px',color:'rgba(255,255,255,0.4)',textTransform:'uppercase',display:'block',marginBottom:'4px'}}>Data fim</label>
                  <input type="date" min={dataInicio||hoje} value={dataFim}
                    onChange={e=>setDataFim(e.target.value)}
                    style={{width:'100%',padding:'7px 10px',background:'rgba(255,255,255,0.1)',border:'1px solid rgba(255,255,255,0.15)',borderRadius:'7px',fontSize:'12px',color:'#fff',fontFamily:'inherit',outline:'none'}}/>
                </div>
                <div style={{display:'flex',gap:'6px'}}>
                  <button onClick={aplicarDatas} disabled={!dataInicio||!dataFim}
                    style={{padding:'7px 14px',background:'var(--orange)',color:'#fff',border:'none',borderRadius:'7px',fontSize:'12px',fontWeight:'600',cursor:'pointer',fontFamily:'inherit',opacity:(!dataInicio||!dataFim)?0.5:1}}>
                    Aplicar
                  </button>
                  {dataActiva && (
                    <button onClick={limparDatas}
                      style={{padding:'7px 12px',background:'rgba(239,68,68,0.2)',color:'#fca5a5',border:'1px solid rgba(239,68,68,0.3)',borderRadius:'7px',fontSize:'12px',cursor:'pointer',fontFamily:'inherit'}}>
                      <XIcon size={12}/>
                    </button>
                  )}
                </div>
              </div>
              {dataActiva && (
                <div style={{marginTop:'8px',fontSize:'11px',color:'rgba(249,115,22,0.9)',display:'flex',alignItems:'center',gap:'5px'}}>
                  <CalendarIcon size={11}/> A mostrar produtos disponíveis de {dataInicio} a {dataFim}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Categorias */}
        <div style={{display:'flex',gap:'8px',marginBottom:'20px',overflowX:'auto',paddingBottom:'4px'}}>
          <button onClick={()=>setActiveCat('')} style={{
            display:'flex',alignItems:'center',gap:'6px',padding:'7px 14px',borderRadius:'20px',fontSize:'12px',
            fontWeight:'500',cursor:'pointer',whiteSpace:'nowrap',fontFamily:'inherit',transition:'all 0.15s',
            background: !activeCat?'var(--orange)':'var(--card)',
            border: !activeCat?'1px solid var(--orange)':'1px solid var(--border)',
            color: !activeCat?'#fff':'var(--text-secondary)',
          }}>
            Todos
          </button>
          {categorias.map(c=>(
            <button key={c.id} onClick={()=>setActiveCat(activeCat===c.slug?'':c.slug)} style={{
              display:'flex',alignItems:'center',gap:'6px',padding:'7px 14px',borderRadius:'20px',fontSize:'12px',
              fontWeight:'500',cursor:'pointer',whiteSpace:'nowrap',fontFamily:'inherit',transition:'all 0.15s',
              background: activeCat===c.slug?'var(--orange)':'var(--card)',
              border: activeCat===c.slug?'1px solid var(--orange)':'1px solid var(--border)',
              color: activeCat===c.slug?'#fff':'var(--text-secondary)',
            }}>
              {c.icone} {c.nome}
            </button>
          ))}
        </div>

        {/* Grid produtos */}
        {carregando ? (
          <div className="grid-3">
            {[1,2,3,4,5,6].map(i=>(
              <div key={i} style={{background:'var(--card)',border:'1px solid var(--border)',borderRadius:'var(--radius-lg)',overflow:'hidden'}}>
                <div style={{height:'130px',background:'var(--surface)',animation:'pulse 1.5s infinite'}}></div>
                <div style={{padding:'11px 13px'}}>
                  <div style={{height:'14px',background:'var(--surface)',borderRadius:'4px',marginBottom:'8px'}}></div>
                  <div style={{height:'11px',background:'var(--surface)',borderRadius:'4px',width:'60%'}}></div>
                </div>
              </div>
            ))}
          </div>
        ) : produtos.length === 0 ? (
          <div className="card" style={{textAlign:'center',padding:'60px 20px'}}>
            <SearchIcon size={48} color='var(--border)'/>
            <div style={{fontSize:'16px',fontWeight:'600',color:'var(--text-primary)',marginBottom:'8px',marginTop:'12px'}}>
              {search ? `Nenhum resultado para "${search}"` : dataActiva ? 'Sem produtos disponíveis nessas datas' : 'Nenhum produto disponível'}
            </div>
            <div style={{fontSize:'13px',color:'var(--text-muted)',marginBottom:'20px'}}>
              {search ? 'Tenta pesquisar com outras palavras.' : dataActiva ? 'Experimenta outras datas ou remove o filtro.' : 'Os fornecedores ainda não publicaram anúncios.'}
            </div>
            {(search || dataActiva) && (
              <div style={{display:'flex',gap:'8px',justifyContent:'center',flexWrap:'wrap'}}>
                {search && <button className="btn btn-outline" onClick={()=>{setSearch('');setSearchInput('');}}>Ver todos os produtos</button>}
                {dataActiva && <button className="btn btn-outline" onClick={limparDatas}>Remover filtro de datas</button>}
              </div>
            )}
          </div>
        ) : (
          <>
            <div style={{fontSize:'13px',fontWeight:'600',marginBottom:'14px',display:'flex',alignItems:'center',justifyContent:'space-between',color:'var(--text-primary)'}}>
              <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                {search ? `Resultados para "${search}"` : activeCat ? categorias.find(c=>c.slug===activeCat)?.nome || 'Categoria' : 'Produtos em destaque'}
                {dataActiva && <span style={{fontSize:'11px',background:'var(--orange-light)',color:'var(--orange-dark)',padding:'2px 8px',borderRadius:'10px',fontWeight:'500'}}><CalendarIcon size={10}/> {dataInicio} → {dataFim}</span>}
              </div>
              <span style={{fontSize:'12px',color:'var(--text-muted)',fontWeight:'400'}}>{produtos.length}{temMais?'+':''} produto{produtos.length!==1?'s':''}</span>
            </div>
            <div className="grid-3">
              {produtos.map((p,i)=>{
                const isFav    = favoritos.has(p.id);
                const destaque = p.destaque === true || (parseFloat(p.rating_medio||0) >= 4.5 && (p.total_reservas||0) >= 3);
                // Show an ad banner spanning all 3 columns after every 6th product
                const adIndex  = Math.floor(i / 6);
                const showAd   = i > 0 && i % 6 === 0 && ads[adIndex % ads.length];
                return (
                  <React.Fragment key={p.id}>
                    {showAd && (
                      <div style={{gridColumn:'1 / -1'}}>
                        <AdBanner ad={ads[adIndex % ads.length]} />
                      </div>
                    )}
                    <div
                      style={{background:'var(--card)',border:'1px solid var(--border)',borderRadius:'var(--radius-lg)',overflow:'hidden',cursor:'pointer',transition:'all 0.15s'}}
                      onClick={()=>navigate(`/cliente/produto/${p.id}`)}
                      onMouseOver={e=>{e.currentTarget.style.borderColor='var(--orange)';e.currentTarget.style.transform='translateY(-2px)';}}
                      onMouseOut={e=>{e.currentTarget.style.borderColor='var(--border)';e.currentTarget.style.transform='translateY(0)';}}>

                      {/* Imagem */}
                      <div style={{height:'130px',position:'relative',overflow:'hidden',background:gradientes[i%gradientes.length],display:'flex',alignItems:'center',justifyContent:'center',fontSize:'44px'}}>
                        {p.fotos?.[0]
                          ? <img src={p.fotos[0]} alt={p.titulo} style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'} />
                          : <PackageIcon size={40} color='rgba(249,115,22,0.5)'/>
                        }
                        <button
                          onClick={e=>toggleFavorito(e,p.id)}
                          style={{position:'absolute',top:'8px',right:'8px',width:'28px',height:'28px',background:'rgba(255,255,255,0.9)',borderRadius:'50%',border:'none',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}}>
                          {isFav
                            ? <BookmarkFillIcon size={13} color='#F97316'/>
                            : <BookmarkIcon size={13} color='#94a3b8'/>
                          }
                        </button>
                        {destaque && <div style={{position:'absolute',top:'8px',left:'8px'}}><span style={{background:'var(--orange-light)',color:'var(--orange-dark)',fontSize:'11px',fontWeight:'600',padding:'3px 9px',borderRadius:'20px'}}>Destaque</span></div>}
                      </div>

                      {/* Info */}
                      <div style={{padding:'11px 13px'}}>
                        <div style={{fontSize:'13px',fontWeight:'600',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',color:'var(--text-primary)',marginBottom:'3px'}}>{p.titulo}</div>
                        <div style={{fontSize:'11px',color:'var(--text-muted)',marginBottom:'5px',display:'flex',alignItems:'center',gap:'3px'}}>
                          <MapPinIcon size={10} color='var(--text-muted)'/>
                          {p.localizacao || 'Luanda'} · {p.opcao_entrega==='ambas'?'Entrega disponível':p.opcao_entrega==='entrega'?'Entrega':'Levantamento'}
                        </div>

                        {/* Fornecedor */}
                        <div style={{display:'flex',alignItems:'center',gap:'5px',marginBottom:'6px'}}>
                          {p.fornecedor_foto
                            ? <img src={p.fornecedor_foto} alt={p.fornecedor_nome} style={{width:'16px',height:'16px',borderRadius:'50%',objectFit:'cover'}} onError={e=>e.target.style.display='none'} />
                            : <div style={{width:'16px',height:'16px',borderRadius:'50%',background:'var(--orange)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'8px',color:'#fff',fontWeight:'700'}}>{(p.fornecedor_nome||'?')[0]}</div>
                          }
                          <span style={{fontSize:'11px',color:'var(--text-muted)'}}>{p.fornecedor_nome || 'Fornecedor'}</span>
                          {p.fornecedor_kyc === 'verificado' && <BadgeCheckIcon size={12} color='var(--success)'/>}
                        </div>

                        {/* Avaliação */}
                        {p.rating_medio > 0 && (
                          <div style={{display:'flex',alignItems:'center',gap:'3px',marginBottom:'6px'}}>
                            <StarIcon size={11} color='#f59e0b' fill='#f59e0b'/>
                            <span style={{fontSize:'11px',fontWeight:'600'}}>{parseFloat(p.rating_medio).toFixed(1)}</span>
                            <span style={{fontSize:'11px',color:'var(--text-muted)'}}>({p.total_reservas||0})</span>
                          </div>
                        )}

                        {/* Preço */}
                        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',paddingTop:'8px',borderTop:'1px solid var(--border)'}}>
                          <div style={{display:'flex',flexDirection:'column',gap:'1px'}}>
                            {p.preco_dia > 0 && (
                              <div style={{fontSize:'14px',fontWeight:'700',color:'var(--orange)'}}>{parseFloat(p.preco_dia).toLocaleString()} Kz<span style={{fontSize:'10px',fontWeight:'400',color:'var(--text-muted)'}}>/dia</span></div>
                            )}
                            {p.disponivel_venda && p.preco_venda > 0 && (
                              <div style={{fontSize: p.preco_dia > 0 ? '11px' : '14px',fontWeight:'700',color:'#16a34a'}}>{parseFloat(p.preco_venda).toLocaleString()} Kz <span style={{fontSize:'9px',fontWeight:'400',color:'var(--text-muted)'}}>compra</span></div>
                            )}
                          </div>
                          <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end',gap:'3px'}}>
                            {p.disponivel_venda && (
                              <span style={{fontSize:'9px',background:'#f0fdf4',color:'#16a34a',border:'1px solid #bbf7d0',padding:'1px 6px',borderRadius:'10px',fontWeight:'600'}}>🛒 Venda</span>
                            )}
                            {p.caucao > 0 && (
                              <div style={{fontSize:'10px',color:'var(--text-muted)',background:'var(--surface)',padding:'2px 7px',borderRadius:'5px'}}>Caução {parseFloat(p.caucao).toLocaleString()} Kz</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
            </div>

            {/* Carregar mais */}
            {temMais && (
              <div style={{textAlign:'center',marginTop:'24px'}}>
                <button
                  onClick={carregarMais}
                  disabled={carregandoMais}
                  className="btn btn-outline"
                  style={{padding:'10px 28px',fontSize:'13px',display:'inline-flex',alignItems:'center',gap:'7px'}}>
                  {carregandoMais
                    ? <><span style={{width:'14px',height:'14px',border:'2px solid var(--orange)',borderTopColor:'transparent',borderRadius:'50%',display:'inline-block',animation:'spin 0.7s linear infinite'}}></span> A carregar...</>
                    : <><ChevronIcon size={14}/> Carregar mais produtos</>
                  }
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}
